document.querySelectorAll('.js-share').forEach((el) => {
  const inputField = el.querySelector('input[type="text"]');
  const submitButton = el.querySelector('button');

  submitButton.addEventListener('click', (e) => {
    e.preventDefault();
    const { value: shareURL, dataset: { shareTitle } } = inputField;
    if (navigator.share) {
      navigator.share({
        title: shareTitle,
        url: shareURL,
      })
        .catch(console.error);
    } else {
      navigator.clipboard.writeText(shareURL);

      inputField.value = 'Gekopieerd naar klembord';

      setTimeout(() => {
        inputField.value = shareURL;
      }, 2000);
    }
  });
});
